import React from 'react'
import GlobalStyles from '../../../../components/component-items/styles'
import { TableCell } from '../../../../components/component-items/datatable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/pro-duotone-svg-icons'
import { LargeButton } from '../../../../components/component-items/buttons'

import type { MerchantUserOverride } from '../../../../types/rbac'
import { SEGMENT_LABELS, LEVEL_LABELS } from '../../../../types/rbac'

// Format date as "Jan 1, 2025"
const formatFriendlyDate = (dateString: string | null) => {
  if (!dateString) return null
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

interface MerchantOverridesTableProps {
  overrides: MerchantUserOverride[]
  onEdit: (override: MerchantUserOverride) => void
  onRemove: (override: MerchantUserOverride) => void
}

export const MerchantOverridesTable = ({ overrides, onEdit, onRemove }: MerchantOverridesTableProps) => {
  if (overrides.length === 0) {
    return (
      <div
        style={{
          padding: '2em',
          textAlign: 'center',
          background: '#f8f9fa',
          borderRadius: '4px',
          color: '#6c7293',
        }}
      >
        No overrides configured. Use overrides to grant or restrict permissions beyond the assigned role.
      </div>
    )
  }

  return (
    <GlobalStyles.DataTable>
      <thead>
        <tr>
          <th>
            <span className="text">Segment</span>
          </th>
          <th>
            <span className="text">Level</span>
          </th>
          <th>
            <span className="text">Company</span>
          </th>
          <th>
            <span className="text">Reason</span>
          </th>
          <th>
            <span className="text center">Created At</span>
          </th>
          <th>
            <span className="text center">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {overrides.map((override) => (
          <tr key={override.id}>
            <TableCell input={SEGMENT_LABELS[override.segment]} />
            <TableCell input={LEVEL_LABELS[override.access_level]} />
            <TableCell input={override.company_name || `Company #${override.company}`} />
            <TableCell
              input={
                <span
                  style={{
                    maxWidth: '200px',
                    display: 'inline-block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  }}
                  title={override.reason}
                >
                  {override.reason || '-'}
                </span>
              }
            />
            <TableCell center input={formatFriendlyDate(override.created_at)} />
            <TableCell
              center
              input={
                <div className="dropdown__container" style={{ display: 'flex', justifyContent: 'center' }}>
                  <GlobalStyles.Tooltip data-title="Edit">
                    <LargeButton onClick={() => onEdit(override)} title="Edit override">
                      <FontAwesomeIcon icon={faEdit} />
                    </LargeButton>
                  </GlobalStyles.Tooltip>
                  <GlobalStyles.Tooltip data-title="Remove">
                    <LargeButton onClick={() => onRemove(override)} title="Remove override">
                      <FontAwesomeIcon icon={faTrash} style={{ color: '#dc3545' }} />
                    </LargeButton>
                  </GlobalStyles.Tooltip>
                </div>
              }
            />
          </tr>
        ))}
      </tbody>
    </GlobalStyles.DataTable>
  )
}

export default MerchantOverridesTable
